'use client'

import { useRef, useEffect } from 'react'

export const useOutsideTouch = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClick = () => {
      callback()
    }

    document.addEventListener('touchstart', handleClick)

    return () => {
      document.removeEventListener('touchstart', handleClick)
    }
  }, [callback, ref])

  return ref
}
